<template>
  <div class="sort">
    <table v-if="headData">
      <thead>
        <tr v-for="(m,j) in headData" :key="m.id">
          <th v-for="(n,i) in m" :colspan="n.col" :style="{'width': n.width+'px'}" :rowspan="n.row" @click.self="btnSort(2,j,i,n.value,n.sort)"
            :key="n.id">{{n.name}}
            <span style="cursor:pointer" v-if="n.sort==true">
              <p><i @click.self="btnSort(0,j,i,n.value,n.sort)" :class="['btn-top',{'active-1':isStatus(j,i,0)}]"></i></p>
              <p><i @click.self="btnSort(1,j,i,n.value,n.sort)" :class="['btn-bot',{'active-2':isStatus(j,i,1)}]"></i></p>
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="m in data" v-if="data&&!custom" :key="m.id">
          <td v-for="n in bodyData" :key="n.id">{{m[n]}}</td>
        </tr>
        <tr v-else-if="!data&&!custom">
          <td>暂无数据</td>
        </tr>
      </tbody>
      <tbody v-if="custom">
        <slot></slot>
      </tbody>
    </table>
  </div>
</template>
<script>
  export default {
    name: 'ep-table',
    data() {
      return {
        theadNum: 2,
        btnState: [],
        isTop: true,
        isBot: false,
        isChange: [0, 0],
        headData: [],
        bodyData: [],
        loadHeadData: []
      }
    },
    props: ['config', 'data', 'custom'],
    created() {
      this.initHeadData(this.config)
    },
    methods: {
      isStatus(i, k, v) {
        if (v == 0) {
          return this.btnState[i][k].isTop
        } else if (v == 1) {
          return this.btnState[i][k].isBot
        } else {
          return
        }
      },
      // 序列化配置文件
      initHeadData(val) {
        if (val) {
          //        console.log(JSON.stringify(val))
          let headArry = [],
            bodyArry = [],
            num = 1
          let round = (data) => {
            for (let i in data) {
              if (i != 'unique') {
                judge(data[i])
              }
            }
          }
          let judge = (data) => {
            if (data.child) {
              round(data.child)
              num = 2
            } else {
              bodyArry.push(data.value)
            }
          }
          round(val)
          console.log(num)
          for (let i = 0; i < num; i++) {
            headArry.push([])
          }
          for (let i in val) {
            if (i != 'unique') {
              let m = val[i]
              if (m.child) {
                headArry[0].push({
                  name: m.name,
                  col: m.child.length,
                  row: 1,
                  width: m.width,
                  value: m.value,
                  sort: m.sort ? true : false
                })
                for (let i in m.child) {
                  if (i != 'unique') {
                    let n = m.child[i]
                    headArry[1].push({
                      name: n.name,
                      col: 1,
                      row: 1,
                      value: n.value,
                      sort: n.sort ? true : false
                    })
                  }
                }
              } else {
                headArry[0].push({
                  name: m.name,
                  col: 1,
                  row: num,
                  width: m.width,
                  value: m.value,
                  sort: m.sort ? true : false
                })
              }
            }
          }
          this.initBtnState(headArry)
          this.headData = headArry
          this.bodyData = bodyArry
        }
      },
      // 初始化按钮状态
      initBtnState(data) {
        let btnState = []
        for (let m in data) {
          btnState.push([])
          for (let n in data[m]) {
            btnState[m].push({
              isTop: false,
              isBot: false
            })
          }
        }
        this.btnState = btnState
      },
      // 排序操作
      btnSort(s, m, n, v, k) {
        if (!k) return
        let changeCopy = [m, n]
        if (JSON.stringify(this.isChange) != JSON.stringify(changeCopy) && s == 2) {
          this.isChange = changeCopy
          this.theadNum = 2
        }
        console.log(s, m, n, v)
        let changeState = (x, y) => {
          this.btnState[m][n].isTop = x
          this.btnState[m][n].isBot = y
        }
        this.initBtnState(this.headData)
        switch (s) {
          case 0:
            //        console.log('向上')
            this.theadNum = 0
            changeState(true, false)
            break;
          case 1:
            //        console.log('向下')
            this.theadNum = 1
            changeState(false, true)
            break;
          case 2:
            //        console.log('无')
            this.theadNum++
            this.theadNum %= 3
            console.log(this.theadNum)
            switch (this.theadNum) {
              case 0:
                changeState(true, false);
                s = 0
                break;
              case 1:
                changeState(false, true)
                s = 1
                break;
              case 2:
                s = 2
                changeState(false, false)
                break;
            }
            break;
        }
        let changeCon = {
          'state': s,
          'value': v
        }
        this.$emit('change', changeCon)
        //      console.log(`状态：${s};属性：${v}`)
      }
    }
  }

</script>
<style lang="css" scoped>
  .sort {
    box-sizing: border-box;
    width: 100%;
    overflow: auto;
  }

  table {
    width: 100%;
    text-align: center;
    border: 1px solid #e6ebf5;
    font-size: 14px;
    color: #5a5e66;
    border-collapse: collapse;
  }

  table thead {
    height: 40px;
    border-bottom: 1px solid #e6ebf5;
    line-height: 40px;
    /* background: #EFEFEF; */
    box-sizing: border-box;
    font-weight: bold;
  }

  table thead span {
    height: 20px;
    vertical-align: middle;
    width: 16px;
    display: inline-block;
    position: relative;
    box-sizing: border-box;
    font-size: 0;
  }

  table thead .iconfont {
    font-size: 10px;
  }

  table thead p {
    line-height: 9px;
    margin-bottom: 0;
    color: #878d99;
    /*cursor: pointer;*/
  }

  table thead p:nth-of-type(1) {
    margin-bottom: 2px;
  }

  table thead th {
    padding: 0;
    margin: 0;
    border: 1px solid #e6ebf5;
  }

  table thead i {
    border-right: 5px solid transparent;
    border-left: 5px solid transparent;
  }

  table thead .btn-top {
    border-top: none;
    border-bottom: 5px solid #97a8be;
    vertical-align: bottom;
  }

  table thead .btn-bot {
    border-bottom: none;
    border-top: 5px solid #97a8be;
    vertical-align: top;
  }

  table thead .active-1 {
    border-bottom-color: #48576a;
  }

  table thead .active-2 {
    border-top-color: #48576a;
  }

  table thead th,
  tbody td {
    text-align: center;
    border-right: 1px solid #e6ebf5;
    text-overflow: hidden;
    white-space: nowrap;
    overflow: hidden;
    /*min-width: 30px;*/
    cursor: default;
    box-sizing: border-box;
  }

  table thead th:nth-last-of-type(1),
  tbody td:nth-last-of-type(1) {
    border-right: none;
  }

  tbody tr {
    line-height: 30px;
    border-bottom: 1px solid #e6ebf5;
    cursor: default;
  }

  tbody tr:hover {
    background: #F7F7F7;
  }

  tbody tr:nth-last-of-type(1) {
    border-bottom: none;
  }
</style>


// WEBPACK FOOTER //
// Table.vue?131c2d2c